import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class ShowcaseFeaturesContainerService  {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getVantagens(id: string): Observable<any> {
    return this.getVantagensContents(id).pipe(
      map(res =>
        this.buildFeatureItensArray(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryVantagensContents[0].data;
  }

  private getVantagensContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryVantagensContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            botoes {
              iv {
                titulo
                cor
                target {
                  ... on Servicos {
                    id
                  }
                }
              }
            }
            itens {
              iv {
                titulo
                subtitulo
                descricao
                linkExterno
                imagem {
                  url
                }
                modal {
                  ... on Modal {
                    id
                  }
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildFeatureItensArray(features: any) {
    let data = [];
    let buttons = [];
    if (features.itens) {
      data = features.itens.iv.map(item => {
        return {
          title: item.titulo || '',
          subtitle: item.subtitulo || '',
          description: item.descricao || '',
          externalLink: item.linkExterno || null,
          img:
            item.imagem && item.imagem[0]
              ? item.imagem[0].url
              : '',
          modal: item.modal ? item.modal : null
        };
      });
    }

    if (features.botoes && features.botoes.iv.length > 0) {
      buttons = features.botoes.iv.map(item => {
        return {
          title: item.titulo || '',
          color: item.cor || '',
          target: item.target && item.target[0] ? item.target[0].id : ''
        };
      });
    }

    return {
      title: features.titulo ? features.titulo.iv : '',
      subtitle: features.subtitulo ? features.subtitulo.iv : '',
      data,
      buttons
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
